module.exports = {
  language: {
    name: 'English'
  },
  header: {
    lang: '中文版',
    home: 'HOME',
    product: 'ABOUT',
    video: 'BATCH',
    news: 'POWER',
    yiyong: 'APPLIED',
    about: 'CONCACT',
    search: 'search',
    langageimg: "cn.png",
    product_info: 'Color Master Batch',
    map_info: 'Main Sales Area',
    product_info_detail: 'Products are widely used in BOPET/PP/PA film, polyester, nylon fiber spinning, pipes, thermoforming products, food packaging, medical packaging, non-woven fabrics, various injection molding products and other fields.',
    yiyong_info: 'Application Fields',
    yiyong_info_detail: 'Products are widely used in BOPET/PP/PA film, polyester, nylon fiber spinning, pipes, thermoforming products, food packaging, medical packaging, non-woven fabrics, various injection molding products and other fields.',
    company_info: 'Introduction',
    company_c: 'Factory',},
  footer: {
    lang: '中文版',
    home: 'HOME',
    product: 'PRODUCT',
    video: 'VIDEO',
    news: 'NEWS',
    yiyong: 'NEWS',
    about: 'ABOUT',
    concact: 'Address：Fengxia Industrial Zone, Mid-section of Dengfeng Road, Guangyi Street, Chenghai District, Shantou City, Guangdong Province.　|　Contact：PHONE：+86 13729250750 TEL 0754-89873673',
    power: 'Copyright FENGZHICAI 2022-2030 All Right Reserved ',
    address: 'Record <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2025436045号</a>'
  }
}



// WEBPACK FOOTER //
// ./src/components/language/en.js